import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { ActivityService } from "@rubbl-activity";
import { AuthenticationService, BaseResolverService, ErrorsHandler, LogService } from "@rubbl-core";
import { NgProgress } from "ngx-progressbar";
import { ToastrService } from "ngx-toastr";
import { User } from "oidc-client";
import { catchError, Observable, tap } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ManageResolverService extends BaseResolverService implements Resolve<any> {
  user: User;
  numOfTries = 0;
  constructor(
    errorHandler: ErrorsHandler,
    toastrService: ToastrService,
    progress: NgProgress,
    private activityService: ActivityService,
    private authenticationService: AuthenticationService,
  ) {
    super(errorHandler, toastrService, progress);
    this.user = this.authenticationService.getUserNonAsync();
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Observable<never> {
    this.startProgressBar();
    // such a hack but since this resolver gets called twice we need to do this timeout. we need to make resolvers for each capability instead of having one big resolver
    return this.activityService.getAllInitialActivities(this.user.profile.account_id).pipe(
      tap(result => {
        this.finishProgressBar();
        if (result.results.length === 0 && this.numOfTries < 6) {
          this.resolve(route, state);
          this.numOfTries++;
          return;
        }

        this.finishProgressBar(); // for some reason it is not stopping
      }),
      catchError(e => {
        this.finishProgressBar();
        return this.logError(e);
      }),
    );
  }
}
